module.exports = __webpack_public_path__ + "static/img/scin.edd3808.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/CGdesign/src/assets/icons/scin.svg
// module id = EV7p
// module chunks = 1